import { InjectionToken } from "@angular/core";

import { AzmToastConfig, AzmToastType } from "./toast.model";

export interface AzmToastInstanceData {
	toastId: number;
	toastType: AzmToastType;
	message: string;
	title?: string;
	config: Required<AzmToastConfig>;
	onRemove: (toastId: number) => void;
}

export const AZM_TOAST_DATA = new InjectionToken<AzmToastInstanceData>("AZM_TOAST_DATA");
